import React, { useEffect, useState } from 'react';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

/** Generic "give a reason" confirmation used by dispute, cancel, reverse payment and batch cancel. */
export default function ReasonDialog({ open, onClose, onConfirm, title, description, confirmLabel, required = true, busy, testId }) {
  const { t } = useTranslation();
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (open) setReason('');
  }, [open]);

  return (
    <Dialog open={open} onClose={busy ? undefined : onClose} maxWidth="xs" fullWidth data-testid={testId}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {description && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            {description}
          </Typography>
        )}
        <TextField
          autoFocus
          fullWidth
          multiline
          minRows={2}
          label={t('purchaseLedger.reason')}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          inputProps={{ 'data-testid': testId ? `${testId}-reason` : undefined }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>
          {t('Cancel')}
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={busy || (required && !reason.trim())}
          onClick={() => onConfirm(reason.trim())}
          startIcon={busy ? <CircularProgress size={16} /> : null}
          data-testid={testId ? `${testId}-confirm` : undefined}
        >
          {confirmLabel || t('Confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
